import React from 'react';

import ProductTile from '@hpstellar/core/ProductTile';

import ProductJsonld from './product-json-ld';

/**
 * Displays ProductTile stellar component and associated jsonld.
 * Use this component in cases where the ProductTile needs to be rendered along with the jsonlds.
 */
export default ({ price, product, ...rest }) => (
    <>
        <ProductTile {...rest} price={price} product={product} />
        {product && <ProductJsonld product={{ ...product }} price={price} />}
    </>
);
